import { emailPattern } from './patterns';

export function isValidEmail(email) {
  return emailPattern.test(email);
}
